import { render, staticRenderFns } from "./Select736Button.vue?vue&type=template&id=6bd4d522&scoped=true"
import script from "./Select736Button.vue?vue&type=script&lang=js"
export * from "./Select736Button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd4d522",
  null
  
)

export default component.exports